import React, { useState } from "react";
import { Tooltip, message } from "antd";
import { LuCheck, LuCopy } from "react-icons/lu";
import copy from "clipboard-copy";

const CopyText = ({
  text,
  children,
  showIcon = true,
  tooltip = "",
  successMessage = "",
  errorMessage = "",
  className = "",
}) => {
  const [copied, setCopied] = useState(false);

  const tooltipText = tooltip || (copied ? "Copied" : "Copy");
  const successMessageText = successMessage || "Copied to clipboard";
  const errorMessageText = errorMessage || "Failed to copy";

  const handleCopy = (e) => {
    e.stopPropagation();

    if (!text) return;

    copy(text)
      .then(() => {
        setCopied(true);
        message.success(successMessageText);
        setTimeout(() => setCopied(false), 1500);
      })
      .catch(() => {
        message.error(errorMessageText);
      });
  };

  const Icon = copied ? LuCheck : LuCopy;

  return (
    <span
      className={`inline-flex items-center gap-2 cursor-pointer ${className}`}
    >
      {children}

      {showIcon && (
        <Tooltip title={tooltipText} open={copied ? true : undefined}>
          <span className="inline-flex" onClick={handleCopy}>
            <Icon
              size={16}
              className={copied ? "text-green-500 cursor-pointer" : "cursor-pointer"}
            />
          </span>
        </Tooltip>
      )}
    </span>
  );
};

export default CopyText;
